import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ListaContactos } from 'src/app/interfaces/ListaContactosData';
import { ListaContactosService } from 'src/app/service/listaContactos.service';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lista-de-contactos',
  templateUrl: './lista-de-contactos.component.html',
  styleUrls: ['./lista-de-contactos.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class ListaDeContactosComponent implements OnInit {
  contactos: ListaContactos[] = [];
  deviceUrl: string = '';
  deviceName: string = '';
  id: string = '';

  constructor(private messageService: MessageService, private router: Router,
    private route: ActivatedRoute, private contactosService: ListaContactosService,
    private confirmationService: ConfirmationService, private translate: TranslateService) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['deviceUrl'];
      const nombre = params['deviceName'];
      if (token) {
        this.getContactos(token);
      }
      if (nombre) {
        this.deviceName = nombre;
      }
    });
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  getContactos(token: string): void {
    this.deviceUrl = token;
    this.contactosService.getAllContactos(token)
      .subscribe(contactos => {
        this.contactos = contactos;
        this.contactos.sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime());

      });
  }

  newListClick(deviceUrl: string, deviceName: string) {
    this.router.navigate(['/new-list'], {
      queryParams: { deviceUrl: this.deviceUrl, deviceName: this.deviceName },
      queryParamsHandling: 'merge'
    })
  }

  regresar(deviceUrl: string, deviceName: string) {
    this.router.navigate(['/campaigns'], {
      queryParams: { deviceUrl: this.deviceUrl, deviceName: this.deviceName },
      queryParamsHandling: 'merge'
    });
  }

  confirmarEliminar(id: string) {
    this.confirmationService.confirm({
      message: this.translate.instant('CONFIRM_DELETE_LIST'),
      accept: () => {
        this.eliminarLista(id);
      }
    });
  }

  eliminarLista(id: string): void {
    this.contactosService.eliminarLista(id)
      .subscribe(() => {
        this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS'), detail: this.translate.instant('SUCCESS_DELETE_LIST') });
        console.log("Lista eliminada correctamente");
        this.getContactos(this.deviceUrl);
      }, error => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('ERROR_DELETE_LIST') })
        console.error("Error al eliminar la lista:", error);
      });
  }

  modificarLista(id: string, deviceUrl: string, deviceName: string) {
    this.router.navigate(['/edit-list', id], {
      queryParams: { deviceUrl: this.deviceUrl, deviceName: this.deviceName },
      queryParamsHandling: 'merge'
    });
  }
 
  contactThreshold = 6; 

  showDialog = false;
  selectedContactName = '';
  allNumbers: string[] = [];
  filteredNumbers: string[] = [];
  filterTerm = '';

 
  private parseNumbers(lista?: string | null): string[] {
    return (lista || '')
      .replace(/[,;]+/g, ' ') 
      .split(/\s+/)
      .map(s => s.trim())
      .filter(Boolean);
  }

  countNumbersStr(lista?: string | null): number {
    return this.parseNumbers(lista).length;
  }

  previewStr(lista?: string | null, take: number = 12): string {
    const nums = this.parseNumbers(lista);
    if (!nums.length) return '—';
    const preview = nums.slice(0, take).join(', ');
    const rest = nums.length - take;
    return rest > 0 ? `${preview} +${rest} más` : preview;
  }

  // --- Abrir modal ---
  openNumbersModal(nombre: string, lista?: string | null): void {
    this.selectedContactName = nombre;
    this.allNumbers = this.parseNumbers(lista);
    this.filteredNumbers = [...this.allNumbers];
    this.filterTerm = '';
    this.showDialog = true;
  }

  trackByIndex(i: number) { return i; }

  previewNoCount(lista?: string | null, take: number = 8): string {
    const nums = this.parseNumbers(lista);
    if (!nums.length) return '—';
    // si hay más elementos, solo ponemos los primeros y un “ … ”
    return nums.length > take ? nums.slice(0, take).join(', ') + ' …' : nums.join(', ');
  }


}

